module.exports = __webpack_public_path__ + "img/shield_done.d8c6996f.svg";